export const HeaderStyles = (theme) => ({
    mainDiv: {
        height: '15vh',
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: `1px solid ${theme.palette.border.thin}`,
    },

    imgDiv: {
        width: 64,
        height: 64,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    imgClass: {
        maxWidth: "100%", maxHeight: "100%"
    },

    welcomeText: {
        color: theme.palette.text.primary
    },

    userText: {
        color: theme.palette.text.primary,
        fontSize: theme.palette.textSize.lg,
        fontWeight: "bold",
    },

    headerIcon: {
        width: 25, height: 25, color: theme.palette.text.primary,
    },

    logoutBtn: {
        borderRadius: 1,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.text.primary,
        px: 1,
        py: 1,
        textTransform: "none",
        minWidth: "auto",
        "&:hover": {
            backgroundColor: theme.palette.background.paper,
        }
    },

        locationBox: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        cursor: "pointer",
        padding: "6px 12px",
        borderRadius: "20px",
        border: `1px solid ${theme.palette.border.thin}`,
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
            transform: "translateY(-1px)",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
        },
    },

    locationIcon: {
        width: 18,
        height: 18,
        color: theme.palette.primary.main,
    },

    locationText: {
        fontSize: "0.85rem",
        color: theme.palette.text.secondary,
        fontWeight: 500,
        maxWidth: "100px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },

    spin: {
        animation: "spin 1s linear infinite",
        "@keyframes spin": {
            "0%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(360deg)" },
        },
    },
})

export const FooterStyles = (theme) => ({
    desktopDiv: {
        position: "fixed",
        bottom: 5,
        left: 0,
        right: 0,
        border: `1px solid ${theme.palette.border.thin}`,
        justifyContent: "center",
        background: theme.palette.background.paper,
        borderRadius: "0.6rem",
        padding: "8px",
        margin: "0 auto",
        width: "max-content",
        display: { xs: "none", lg: "block" },
    },

    active: {
        display: "flex",
        flexDirection: "column",
        padding: "30px 16px",
        borderRadius: 1,
        boxShadow: "none",
        color: theme.palette.text.primary,
        bgcolor: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
        "&:hover": {
            bgcolor: theme.palette.background.paper,
            color: theme.palette.primary.main,
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },

    inactive: {
        display: "flex",
        flexDirection: "column",
        padding: "30px 16px",
        borderRadius: 1,
        border: "none",
        color: theme.palette.user.grey,
        bgcolor: "transparent",
        "&:hover": {
            bgcolor: "rgba(0,0,0,0.05)",
        },
    },

    labelText: {
        fontSize: theme.palette.textSize.sm,
        fontWeight: 500
    },

    mobVersion: {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        display: { xs: "block", lg: "none" },
    },

    mobileActive: {
        "&.Mui-selected": {
            color: theme.palette.primary.main,
        },
    }
})


export const logoutStyles = (theme) => ({
    rootDiv: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        my: 2,
    },

    title: {
        fontWeight: "bold",
        fontSize: theme.palette.textSize.xl,
        textAlign: "center",
        pb: 1,
    },

    subtitle: {
        textAlign: "center",
        fontSize: theme.palette.textSize.md,
        color: "text.secondary",
    },

    btnDiv: {
        justifyContent: "center",
        gap: 2,
        pb: 2
    },
})
